/** "Updated hh:mm" — when a screen's data last loaded (it refetches when the window regains focus). */
import { useTranslation } from 'react-i18next';
import { formatUpdated } from '@/lib/dates';
import { Icon } from './Icons';

export function Updated({ at, fetching }: { at: number; fetching?: boolean }) {
  const { t, i18n } = useTranslation();
  if (!at) return null;
  return (
    <span className="updated help" data-testid="updated">
      <Icon name="refresh" width={14} height={14} aria-hidden="true" />
      {fetching ? t('updated.refreshing') : t('updated.at', { time: formatUpdated(at, i18n.language) })}
    </span>
  );
}
